<template>
  <router-view />
</template>

<script>
export default {
  name: "inventory",
};
</script>